module.exports = __webpack_public_path__ + "static/media/tyre-low.8c020658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-low.png
// module id = 86
// module chunks = 0